export const NAVIGATION_DETAILS_REQUEST = 'NAVIGATION_DETAILS_REQUEST';
export const NAVIGATION_DETAILS_SUCCESS = 'NAVIGATION_DETAILS_SUCCESS';
export const NAVIGATION_DETAILS_FAILURE = 'NAVIGATION_DETAILS_FAILURE';

export const CLEAR_NAVIGATION_DETAILS = 'CLEAR_NAVIGATION_DETAILS';

export const CHANGE_NAVIGATION_CONTEXT = 'CHANGE_NAVIGATION_CONTEXT';

export const TOGGLE_NAVIGATION_MENU = 'TOGGLE_NAVIGATION_MENU';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';

export const BLOCK_NAVIGATION = 'BLOCK_NAVIGATION';
export const SET_PROMPT_INFO = 'SET_PROMPT_INFO';

export const RESET_NOTIFICATION = 'RESET_NOTIFICATION';
